import React, {useContext} from "react";
import Switch from "../common/Switch";
import {UserContext} from "../common/UserContext";

const RightMenuSwitch = props => {
    const {user, toggleContextMenuRight} = useContext(UserContext);

    return (
        <div>
            <label>
                <Switch size="small" color="primary" name="contextMenuRight" defaultChecked={user.contextMenuRight} onChange={toggleContextMenuRight} />
                Right side menu
            </label>
        </div>
    )
}

export default RightMenuSwitch;